<div fxLayoutGap="20px" class="card card-class">
    <h5 class="card-title"><mat-icon>group</mat-icon>Students</h5>
      <div class="card-body card-details">
  
       <!-- <div>
        <div class="profile-card">
          <img src="/assets/exams_img.svg">
          <div class="header">
            <h3>This space is empty!</h3>
            No Class available to display. Use the button below to add one or more classes. 
            We promise you would not see this again after you have successfully added a class.
          </div>  
      </div>   
          <div class="form-group buttons">
            <button class="btn btn-primary next" (click)="openDialogClass()">Add Class</button>
          </div> 
       </div> -->
           
         
       <!-- <div class="form-group buttons">
        <button class="btn btn-primary next" (click)="openDialogClass()">Add Class</button>
      </div> -->
      <button class="btn add-new-user" (click)="openDialogStudent()"><i class="fas fa-plus"></i>ADD STUDENT</button> 
        <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
          <div fxFlex="20%" *ngFor="let student of studentData">
            <mat-card class="mat-elevation-z4" >
              <mat-card-content>
                  <mat-icon class="center-icon">group</mat-icon>
                <p>
                  {{student.firstName}}  {{student.lastName}}
                </p>
              </mat-card-content>
              <mat-card-actions>
                <mat-icon (click)="editStudent(student)">edit</mat-icon>
                <mat-icon (click)="deleteStudent(student)">delete</mat-icon>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
    </div>
  </div>
